<template lang="pug">
    div.select-organization
        el-dialog(
            :title="selectOrgData.orgType === 'CORPORATION'? '请选择集团':'请选择店铺'"
            :visible.sync="selectOrgData.show"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="460px"
            center
        )
            //- edit: 显示关闭按钮
            div.close-svg(
                v-if="selectOrgData.type === 'edit' || selectOrgData.type === 'add'"
                @click="closeDialog"
            )
                svg-icon(icon-class="close")
            div(
                v-loading="loading"
            )
                section(v-if="selectOrgData.orgType === 'STORE'")
                    el-form.form(
                        v-show="orgType === 'STORE'"
                        :model="orgForm"
                        :rules="rules"
                        ref="orgForm"
                        label-width="80px"
                    )
                        el-form-item(
                            prop="orgId"
                            label="请选择："
                        )
                            el-cascader(
                                style="width: 260px"
                                v-model="orgForm.orgId"
                                :options="options"
                                :props="optionsProps"
                                :placeholder="'请输入店铺名称搜索'"
                                filterable
                                clearable
                            )
                section(v-else)
                    // TODO 此处'ALL'已经废弃，确认业务后可删除
                    div.select-organization-content(
                        v-if="selectOrgData.orgType === 'ALL'"
                    )
                        div.select-organization-content-radio(
                            :class="orgType === 'CORPORATION' ? 'active' : ''"
                            @click="changeModel('CORPORATION')"
                        )
                            svg-icon.icon(
                                :icon-class="orgType === 'CORPORATION' ? 'group-active' : 'group'"
                            )
                            el-radio(
                                v-model="orgType"
                                label="CORPORATION"
                            ) 集团模式
                        div.select-organization-content-radio(
                            :class="orgType === 'STORE' ? 'active' : ''"
                            @click="changeModel('STORE')"
                        )
                            svg-icon.icon(
                                :icon-class="orgType === 'STORE' ? 'single-active' : 'single'"
                            )
                            el-radio(
                                v-model="orgType"
                                label="STORE"
                            ) 单店模式
                    div.line(
                        v-if="selectOrgData.orgType === 'ALL'"
                    )
                    el-form.form(
                        :model="orgForm"
                        :rules="rules"
                        ref="orgForm"
                        label-width="80px"
                    )
                        el-form-item(
                            prop="orgId"
                            label="请选择："
                        )
                            el-cascader(
                                style="width: 260px"
                                v-model="orgForm.orgId"
                                :options="options"
                                :props="optionsProps"
                                :placeholder="'请输入组织名称搜索'"
                                filterable
                                clearable
                            )
            span(
                    slot="footer"
                )
                el-button.footer-button(
                    style="width: 110px"
                    @click="handleSubmit"
                    type="primary"
                    round
                ) 确定
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
    loginApis,
} from '@/api';
import { handleParameter } from '@/filters';

export default {
    name: 'SelectOrganization',
    data() {
        return {
            loading: false,
            // ALL包含集团   STORE：单店版 多店版： MULTIPLE
            orgType: '',
            options: [],
            optionsProps: {
                label: 'name',
                value: 'id',
                children: 'childs',
            },
            orgForm: {
                orgId: '',
            },
            rules: {
                orgId: [
                    {
                        required: true,
                        message: '请选择',
                        trigger: [
                            'blur', 'change',
                        ],
                    },
                ],
            },
            dilogVisible: false,
        };
    },
    props: {
        selectOrgData: {
            type: Object,
            default: () => ({
                show: false,
                type: 'add',
                id: '',
                orgId: '',
                orgType: '',
                mode: '',
                changeType: false,
            }),
        },
    },
    computed: {
        ...mapState('user', [
            'userInfo',
        ]),
    },
    mounted() {
        // 之前选的是多店模式
        this.orgType = this.selectOrgData.orgType;
        // if (this.selectOrgData.orgType !== 'ALL') {
        //     this.currentTitle = this.selectOrgData.orgType === 'CORPORATION' ? '请选择集团' : '请选择单店';
        // }
        this.getUserOrgData();
    },
    methods: {
        ...mapActions('user', [
            'resetUserOrgsType',
        ]),
        closeDialog() {
            this.$emit('closeDialog');
            this.selectOrgData.show = false;
        },
        async getUserOrgData() {
            this.loading = true;
            const type = this.orgType;
            try {
                const { data } = await loginApis.getUserOrg({
                    orgType: type,
                });
                this.loading = false;
                this.options = data;
            } catch (e) {
                throw e;
            }
        },
        changeModel(key) {
            if (this.orgType === key) return;
            let str = '';
            if (key === 'STORE') {
                str = '单店模式';
            } else {
                str = '集团模式';
            }
            handleParameter({
                trackKey: 'nav_select_organization_popup_change_model',
                attr: {
                    change_model: str,
                },
            });
            this.orgType = key;
            this.orgForm.orgId = '';
            this.getUserOrgData();
        },
        async handleSubmit() {
            // 默认值：单店的mode
            let mode = 1;
            // 集团版
            if (this.selectOrgData.orgType === 'CORPORATION') {
                mode = 3;
            }
            this.$refs.orgForm.validate(async (valid) => {
                if (!valid) return;
                try {
                    await loginApis.checkOrg({
                        orgId: this.orgForm.orgId[this.orgForm.orgId.length - 1],
                        mode,
                    });
                    this.selectOrgData.show = false;
                    this.$emit('refresh');
                } catch (err) {
                    throw new Error(err);
                }
            });
            this.resetUserOrgsType(this.selectOrgData.orgType);
        },
    },
};
</script>

<style lang="scss">
    .select-organization {
        .el-form .el-form-item__label {
            line-height: 40px;
        }
        .el-form .el-form-item {
            margin-bottom: 0;
        }
        .el-dialog .el-dialog__body {
            padding-bottom: 0;
            overflow-y: hidden!important;
        }
    }
    .close-svg {
        position: absolute;
        right: 10px;
        top: 15px;
        cursor: pointer;
    }
</style>

<style lang="scss" scoped>
    .select-organization {
        &-content {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            margin-bottom: 30px;
            .active {
                border:1px solid;
                @include border_color(color_base_blue4);
            }
            &-radio {
                width: 140px;
                height: 140px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                box-shadow:0 5px 20px 0 rgba(0,0,0,0.1);
                border-radius:10px;
                cursor: pointer;
                .icon {
                    width: 52px;
                    height: 52px;
                    margin-bottom: 20px;
                }
            }
        }
        .line {
            width: 340px;
            height: 1px;
            margin: 0 0 20px 30px;
            @include bg_color(color_base_gray4);
        }
        .form {
            margin-left: 30px
        }
    }
</style>
